import { render, staticRenderFns } from "./PersonalInformation.vue?vue&type=template&id=43d3894b&"
import script from "./PersonalInformation.vue?vue&type=script&setup=true&lang=js&"
export * from "./PersonalInformation.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports